import { configureStore } from '@reduxjs/toolkit';
import signInReducer from '../auth/SignInScreen/SigninStore/signinSlice';
import forgetPwdReducer from '../auth/ForgetPwdScreen/ForgetPwdStore/forgetPwdSlice';
import commonStoreReducer from '../../src/containers/common/CommonStore/CommonStoreSlice';
import discountStoreReducer from '../containers/ApprovalManagement/ManagementAppApproval/DiscountStore/discountStoreSlice';
import admissionFeeReducer from '../containers/ApprovalManagement/DiscoveryAppApproval/AdmissionFeeStore/AdmissionFeeSlice';
import confirmAdmissionReducer from '../containers/ApprovalManagement/ConfirmAdmissionScreen/ConfirmAdmissionStore/ConfirmAdmissionSlice';
import transactionInvoicesReducer from '../containers/ApprovalManagement/TransactionInvoices/TransactionInvoicesStore/transactionInvoicesSlice';
import setupInvoicesReducer from '../containers/ApprovalManagement/SetupInvoicesScreen/SetupInvoicesStore/setupInvoicesSlice';
import paymentMethodReducer from '../containers/ApprovalManagement/PaymentMethodScreen/PaymentMethodStore/paymentMethodSlice';
import dashboardReducer from '../containers/Dashboard/DashboardStore/dashboardSlice';
import dashboardManagementReducer from '../containers/Dashboard/ManagementAppDashboard/ManagementAppStore/managementDashboardSlice';
import dashboardDiscoverReducer from '../containers/Dashboard/DiscoverAppDashboard/DiscoverAppStore/discoverAppSlice';
import managementAppFinanceReducer from '../containers/FinanceManagement/ManagementAppFinance/ManagementAppFinanceStore/managementAppFinanceSlice';
import userKycApproveReducer from '../containers/ApprovalManagement/UserKycApprove/UserKycApproveStore/userKycApproveSlice';
import approvalReducer from '../containers/ApprovalManagement/ApprovalStore/approvalSlice';
import userReducer from '../containers/Atheneum/User/UserStore/userStoreSlice';
import cartReducer from '../containers/Atheneum/Cart/CartStore/cartStoreSlice';
import wishlistReducer from '../containers/Atheneum/Wishlist/WishlistStore/wishlistStoreSlice';
import coursesReducer from '../containers/Atheneum/Courses/CourseStore/courseStoreSlice';
import offerReducer from '../containers/Atheneum/Offer/OfferStore/offerStoreSlice';
import orderReducer from '../containers/Atheneum/Orders/OrderStore/orderStoreSlice';
import programReducer from '../containers/Atheneum/Programs/ProgramStore/programStoreSlice';
import appListReducer from '../containers/Dashboard/AppsListDash/AppListStore/appListStoreSlice';
import managementStoreReducer from '../containers/UserManagement/ManagementStore/ManagementStoreSlice';
import partialRolloutReducer from '../containers/LaunchManagement/PartialRollout/PartialRolloutStore/partialRolloutSlice';
import launchReducer from '../containers/LaunchManagement/Launch/LaunchStore/launchSlice';
import bccUserReducer from '../containers/UserManagement/bccUser/bccUserStore/bccUserStoreSlice';
import akademyReducer from '../containers/Akademy/AkademySlice';
import GeneratedReducer from '../containers/AffiliatedMarketing/GeneratedLeads/GeneratedStore/generatedStoreSlice';
import ConvertedReducer from '../containers/AffiliatedMarketing/ConvertedLeads/ConvertedStore/convertedStoreSlice';
import FeaturedSchoolReducer from '../containers/LaunchManagement/FeaturedSchool/FeaturedSchoolStore/FeaturedSchoolSlice';
import approvalManagementReducer from '../containers/ApprovalManagement/ManagementAppApproval/ManagementStore/managementStoreSlice';
import teenybeansReducer from '../containers/TeenybeansPortal/TeenybeansSchools/bccTeenybeansStore/bccTeenybeansStoreSlice';
import hashtagsReducer from '../containers/Dashboard/Hashtags/HashtagstStore/hashtagsSlice';
import buzzOneReducer from '../containers/BuzzOne/BuzzOneSlice';
import buzzReducer from '../containers/Dashboard/BuzzSlice';
import featureFlagsReducer from '../containers/Dashboard/FeatureManagement/featureFlagsSlice';
import trainingCertificateReducer from '../containers/Atheneum/Certification/CertificationStore/CertificationStoreSlice';

const store = configureStore({
  reducer: {
    signInReducer,
    forgetPwdReducer,
    commonStoreReducer,
    discountStoreReducer,
    admissionFeeReducer,
    confirmAdmissionReducer,
    paymentMethodReducer,
    transactionInvoicesReducer,
    setupInvoicesReducer,
    dashboardReducer,
    dashboardManagementReducer,
    dashboardDiscoverReducer,
    managementAppFinanceReducer,
    approvalReducer,
    approvalManagementReducer,
    userKycApproveReducer,
    userReducer,
    cartReducer,
    wishlistReducer,
    coursesReducer,
    offerReducer,
    orderReducer,
    programReducer,
    appListReducer,
    partialRolloutReducer,
    managementStoreReducer,
    bccUserReducer,
    launchReducer,
    akademyReducer,
    GeneratedReducer,
    ConvertedReducer,
    FeaturedSchoolReducer,
    teenybeansReducer,
    hashtagsReducer,
    buzzOne: buzzOneReducer,
    buzz: buzzReducer,
    featureFlags: featureFlagsReducer,
    trainingCertificateReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
